export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7456.4b4ece78.jpg";